import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataPatientCaseEndoRecallModel} from "../models/data-patient-case-endo-recall.model";
import {NoteDataModel} from "../../../models/notes/note-data.model";
import {PatientCaseEndoFinalReportDataModel} from "../../../models/finalReport/patient-case-endo-final-report-data.model";
import {PatientService} from "../../patient/patient.service";
import {Globals} from "../../../globals";
import {EnumValidValueItemModel} from "../../../models/enum/enum-valid-value-item.model";
import {StaticDataService} from "../../../services/static-data.service";


// tslint:disable-next-line:no-empty-interface
export interface RecallPrintData {
  recalls: DataPatientCaseEndoRecallModel[];
  finalReport: PatientCaseEndoFinalReportDataModel;
  notes: NoteDataModel[];
  images: any[];
}

// tslint:disable-next-line:no-empty-interface
export interface RecallPrintResult {
  printed: boolean;
}

@Component({
  selector: 'app-recall-print-modal',
  templateUrl: './recall-print-modal.component.html',
  styleUrls: ['./recall-print-modal.component.css']
})

export class RecallPrintModalComponent implements OnInit {
  printed: boolean = false;

  recalls: DataPatientCaseEndoRecallModel[] = [];
  finalReport: PatientCaseEndoFinalReportDataModel = null;
  notes: NoteDataModel[] = [];
  images: any[] = [];

  patient: string = '';


  probingValues: EnumValidValueItemModel[] = [];
  sinusValues: EnumValidValueItemModel[] = [];
  findingValues: EnumValidValueItemModel[] = [];
  mobilityValues: EnumValidValueItemModel[] = [];
  percussValues: EnumValidValueItemModel[] = [];
  palpValues: EnumValidValueItemModel[] = [];
  pdlidValues: EnumValidValueItemModel[] = [];
  lucencyValues: EnumValidValueItemModel[] = [];
  asymValues: EnumValidValueItemModel[] = [];
  coronalValues: EnumValidValueItemModel[] = [];
  restoredValues: EnumValidValueItemModel[] = [];
  timeValues: EnumValidValueItemModel[] = [];
  docTags: EnumValidValueItemModel[] = [];
  nextRecallOpts: EnumValidValueItemModel[] = [];
  statusEnums: EnumValidValueItemModel[] = [];
  recallEnums: EnumValidValueItemModel[] = [];
  prognosisEnums: EnumValidValueItemModel[] = [];
  medicalSpecialtyEnums: EnumValidValueItemModel[] = [];
  caseTypeEnums: EnumValidValueItemModel[] = [];
  restorationMethodEnums: EnumValidValueItemModel[] = [];
  treatmentSessionsEnums: EnumValidValueItemModel[] = [];
  caseRatingEnums: EnumValidValueItemModel[] = [];


  constructor(
    public dialogRef: MatDialogRef<RecallPrintModalComponent, RecallPrintResult>,
    @Inject(MAT_DIALOG_DATA) public data: RecallPrintData,
    public patientService: PatientService,
    public globals: Globals,
    public staticDataService: StaticDataService
  )
  {
    this.patientService.getPatientNameAndAge();
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    } else {
      this.setupEnums();
    }
    this.recalls = this.data.recalls;
    this.images = this.data.images;
    this.notes = this.data.notes;
    this.finalReport = this.data.finalReport;
  }

  ngOnInit(): void {
    console.log(this.recalls);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  print(): void {
    const printContents = document.getElementById('printContainer').innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;

    this.dialogRef.close({printed: true});
  }

  setupEnums() {
    this.probingValues = this.staticDataService.getValidValueItemsByValidValueName('enumProbingDepth');
    this.sinusValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallSinusTrack');
    this.findingValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallCurrentFinding');
    this.mobilityValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallMobility');
    this.percussValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallPercuss');
    this.palpValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallPalpSore');
    this.pdlidValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallPDL');
    this.lucencyValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallLucencyI');
    this.asymValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallAsymFunc');
    this.coronalValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallCoronalLeak');
    this.restoredValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallToothResored');
    this.timeValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallInTime');
    const allTags = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag');
    this.nextRecallOpts = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRecall');
    this.statusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportCaseStatus');
    this.prognosisEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportPrognosis');
    this.recallEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRecall');
    this.medicalSpecialtyEnums = this.staticDataService.getValidValueItemsByValidValueName('enumMedicalSpecialty');
    this.caseTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseType');
    this.restorationMethodEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRestorationMethod');
    this.treatmentSessionsEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTreatmentSessions');
    this.caseRatingEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseRating');
    // FinalReportRecallID

    // for (let i = 0; allTags.length; i++) {
    //   if (allTags[i].ItemDisplayValue.includes('recall')) {
    //     this.docTags.push(allTags[i]);
    //   }
    // }
  }

}
